import { createCRUDHook } from './createCRUDHook';
import { StoreItemDto, SlugDto } from 'utils/models';
import {
  ECG_STORE_ITEM,
  GET_ALL_STORE_ITEM_DETAILS,
  GET_PART_OR_STORE_ITEM_DETAIL_BY_SLUG,
} from './apiEndPoints';

interface StoreItemCustomOperations {
  getAllStoreItemDetails: (id: number) => Promise<any>;
  getPartOrStoreItemDetailBySlug: (slug: string) => Promise<SlugDto>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  StoreItemDto,
  StoreItemDto[],
  StoreItemCustomOperations
>({
  entityName: 'StoreItem',
  endpoint: ECG_STORE_ITEM,

  customOperations: (auth) => ({
    getAllStoreItemDetails: async (id: number): Promise<any> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          ECG_STORE_ITEM + GET_ALL_STORE_ITEM_DETAILS + `?itemId=${id}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getPartOrStoreItemDetailBySlug: async (slug: string): Promise<SlugDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          ECG_STORE_ITEM +
            GET_PART_OR_STORE_ITEM_DETAIL_BY_SLUG +
            `?slug=${slug}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const StoreItemContext = Context;
export const useStoreItemManager = useManager;
export const useStoreItem = useConsumer;
